/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersinviterotateconfirm3Inputs */

const en_membersinviterotateconfirm3 = /** @type {(inputs: Membersinviterotateconfirm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The old link stops working. Create a new one?`)
};

const de_membersinviterotateconfirm3 = /** @type {(inputs: Membersinviterotateconfirm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der alte Link funktioniert dann nicht mehr. Neuen Link erstellen?`)
};

/**
* | output |
* | --- |
* | "The old link stops working. Create a new one?" |
*
* @param {Membersinviterotateconfirm3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersinviterotateconfirm3 = /** @type {((inputs?: Membersinviterotateconfirm3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersinviterotateconfirm3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersinviterotateconfirm3(inputs)
	return de_membersinviterotateconfirm3(inputs)
});
export { membersinviterotateconfirm3 as "membersInviteRotateConfirm" }